<template>
	<div class="column-key-map-wrapper">
		<label class="inline-block" style="width:47.5%;">External</label>

		<label class="inline-block">Internal</label>

		<repeatable-input v-model="columnKeyMapLocal" :proto="[{external: '', internal: ''}]">
			<template v-slot:default="{ row, rowIndex }">
				<input data-form-type="other" :data-w-input="`column-map-${rowIndex}-external-key`" type="text" placeholder="crm field key" class="w-full border border-gray-200 rounded focus:border-green-500 focus:ring-transparent text-gray-600" v-model="row.external">

				<span style="font-size:1.5em;"> = </span>

				<select
            v-model="row.internal"
            :data-w-input="`column-map-${rowIndex}-column`"
            class="w-full border border-gray-200 rounded focus:border-green-500 focus:ring-transparent text-gray-600"
        >
					<option value="" disabled>lead table column</option>

					<option v-for="column in leadTableColumnsOptions" :key="column" :value="column" :hidden="column.startsWith('scn.')">{{ column }}</option>
				</select>
			</template>
		</repeatable-input>
	</div>
</template>

<script>

import {leadColumns} from "../../lib/helpers";
import {add as addCustomQuestion} from "../../lib/CustomQuestion";

export default {
	data() {
		return {
			customQuestionID: '',
			customLeadColumns: [],
		}
	},
	props: {
		leadTableColumns: {type: Array, required: true},
		value: {required: true},
	},
	computed: {
		columnKeyMapLocal: {
			get() {
				return this.value
			},
			set(value) {
				addCustomQuestion(this, value, 'internal', 'leadTableColumnsOptions')
				this.$dispatch("input", value)
			}
		},
		leadTableColumnsOptions() {
			return leadColumns(this.customLeadColumns);
		}
	},
	created() {
		this.customLeadColumns.push(...this.leadTableColumns);

		this.value.forEach(row => {
			if (row.internal.startsWith('{{CQ:')) {
				this.customLeadColumns.push(row.internal);
			}
		});
	}
}
</script>

<style scoped lang="scss">
	label {
		font-size: .8rem;
	}
</style>
